var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnteredGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 395.7 395.7",
    style: {
      enableBackground: "new 0 0 395.7 395.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00CFB7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.8,0C122.1,0,60.5,61.6,60.5,137.3c0,72.9,124.6,243.2,129.9,250.4l5,6.7c0.6,0.8,1.5,1.3,2.5,1.3 c1,0,1.9-0.5,2.5-1.3l4.9-6.7c5.3-7.2,129.9-177.5,129.9-250.4C335.2,61.6,273.6,0,197.8,0z M197.8,88.1 c27.1,0,49.2,22.1,49.2,49.2c0,27.1-22.1,49.2-49.2,49.2c-27.1,0-49.2-22.1-49.2-49.2C148.7,110.2,170.7,88.1,197.8,88.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnteredGreen);
export default __webpack_public_path__ + "static/media/entered-green.9ad2398aacc8f9719f9953d586cd04aa.svg";
export { ForwardRef as ReactComponent };